import { BEFORE_AFTER } from "@/data/content";
import { Reveal } from "@/lib/motion";
import BeforeAfter from "@/components/BeforeAfter";

export default function BeforeAfterSection() {
    return (
        <section id="avant-apres" className="py-24 md:py-32 bg-white" data-testid="before-after-section">
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="text-center mb-14 max-w-2xl mx-auto">
                    <Reveal><span className="uppercase text-xs tracking-[0.2em] font-bold text-brand-red font-body">{BEFORE_AFTER.kicker}</span></Reveal>
                    <Reveal delay={0.05}><h2 className="text-3xl md:text-5xl font-medium tracking-tight text-navy mt-4 mb-5 font-display">{BEFORE_AFTER.title}</h2></Reveal>
                    <Reveal delay={0.1}><div className="h-px w-16 bg-brand-red mx-auto mb-6" /></Reveal>
                    <Reveal delay={0.12}><p className="text-base text-slate-500 font-body">{BEFORE_AFTER.intro}</p></Reveal>
                    <Reveal delay={0.16}><p className="text-xs text-slate-400 font-body mt-3 uppercase tracking-wider">Glissez pour révéler le résultat</p></Reveal>
                </div>

                <div className="grid md:grid-cols-3 gap-8">
                    {BEFORE_AFTER.items.map((it, i) => (
                        <Reveal key={it.title} delay={i * 0.1} y={0}>
                            <BeforeAfter img={it.img} title={it.title} desc={it.desc} testid={`before-after-card-${i}`} />
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
